import { useState } from 'react'
import { info } from '../services/sentryLogger'

export type AlertState = {
    // title?: string,
    // setTitle?: React.Dispatch<React.SetStateAction<string>>,
    // alertTxt?: string,
    // setAlertTxt?: React.Dispatch<React.SetStateAction<string>>,
    // onConfirm?: () => void,
    // setOnConfirm?: React.Dispatch<React.SetStateAction<() => void>>,
    alert?: (title: string, body: string, onConfirm: () => void) => void
}
export type AlertProps = {
    open: boolean
    title: string
    message: string
    onConfirm: () => void
    onCancel: () => void
}
export const useAlert = () => {
    const [alertTitle, setAlertTitle] = useState('')
    const [alertTxt, setAlertTxt] = useState('')
    const [onConfirm, setOnConfirm] = useState<() => void>(() => () => {})
    const alertState: AlertState = {
        alert: (title, body, onConfirm) => {
            info('App alert', { title, body })
            setAlertTitle(title)
            setAlertTxt(body)
            setOnConfirm(() => {
                onConfirm && onConfirm()
                setAlertTxt('')
            })
        },
    }
    return {
        alertState,
        alertProps: {
            open: !!alertTxt,
            title: alertTitle,
            message: alertTxt,
            onConfirm: onConfirm,
            onCancel: () => setAlertTxt(''),
        },
    }
}
